import { ViewStyle } from "react-native";

export const defaultButtonStyle: ViewStyle = {
  borderRadius: 10,
  height: 50,
};
